import React, {useState, useEffect} from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import {toast} from 'react-toastify'
import InformatonForm from './AddEditInfo'
const AdditionalInfoList = () => {
  const [userData, setUserData] = useState({})
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const loginUserId = localStorage.getItem('loggedInUserID')
  useEffect(() => {
    fetchClaimLimits(loginUserId);
  }, [loginUserId,modalVisible])

  const fetchClaimLimits = async id => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Policy/GetBrokerDetails?userId=${id}`,
        'GET',
      )
      if (response.success) {
        setUserData(response.data)
      } else {
        // toast.error(response.message || 'Failed to fetch claim limits')
      }
    } catch (error) {
      toast.error('Error fetching claim limits')
    }
  }

  const handleCreate = () => {
    setSelectedId(null)
    setModalVisible(true)
  }

  const handleEdit = () => {
    setSelectedId(userData?.id)
    setModalVisible(true)
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchClaimLimits()
  }

  return (
    <div title="User Details" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>Additional Information</h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6}>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <div className="create-quotation">
            <Button
              type="primary"
              onClick={Object.keys(userData).length > 0 ? handleEdit : handleCreate}>
              {Object.keys(userData).length > 0 ? 'Update Info' : 'Add Info'}
            </Button>
            </div>
          </Col>
        </Row>
      </div>



      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Account Holder</h3>
            <p>{userData?.accountHolderName}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Account Number</h3>
            <p>{userData?.accountNumber || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>SWIFT/BIC</h3>
            <p>{userData?.ifsc || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Bank Address</h3>
            <p>{userData?.bankAddress || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Bank Name</h3>
            <p>{userData?.bankName || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Firm Name</h3>
            <p>{userData?.firmName || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Address 1</h3>
            <p>{userData?.addressLine1}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Address 2</h3>
            <p>{userData?.addressLine2}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>City</h3>
            <p>{userData?.city || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>State</h3>
            <p>{userData?.state || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Postal Code</h3>
            <p>{userData?.postalCode || '-'}</p>
          </Col>
        </Row>
      </div>
      <Modal
        title={selectedId ? 'Edit Bank Information' : 'Add Bank Information'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <InformatonForm
          brokerID={selectedId}
          modalVisible={modalVisible}
          onSuccess={handleModalClose}
        />
      </Modal>
    </div>
  )
}

export default AdditionalInfoList
